import { NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE } from '../reducers/activity-creation'

export const selectIsActivityTypeStep = (state: any) =>
    state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE].isActivityTypeStep
export const selectActivityTypeList = (state: any) =>
    state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE].activityTypeList
export const selectSelectedActivityType = (state: any) =>
    state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE].selectedActivityType
export const selectActiveActivity = (state: any) =>
    state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE].activeActivity
export const selectCurrentStep = (state: any) =>
    state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE].currentStep
